import { useEffect, useState } from 'react';
import { differenceInCalendarDays, parseISO, format } from 'date-fns';

export function CountdownWidget({
  config,
}: {
  config?: Record<string, unknown>;
}) {
  const title = String(config?.title || 'Countdown');
  const target = String(
    config?.target || new Date(Date.now() + 7 * 864e5).toISOString().slice(0, 10)
  );
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(t);
  }, []);

  let days = 0;
  try {
    days = differenceInCalendarDays(parseISO(target), now);
  } catch {
    days = 0;
  }

  const label =
    days > 0 ? `${days}` : days === 0 ? '0' : `${Math.abs(days)} ago`;

  return (
    <div className="flex h-full flex-col items-center justify-center text-center">
      <h3 className="text-sm font-bold uppercase tracking-wide text-slate-400">
        {title}
      </h3>
      <div className="mt-1 text-5xl font-black tabular-nums text-violet-400">
        {days >= 0 ? days : Math.abs(days)}
      </div>
      <div className="text-sm text-slate-400">
        {days > 0 ? 'days to go' : days === 0 ? 'is today!' : 'days ago'}
      </div>
      <div className="mt-1 text-xs text-slate-500">
        {(() => {
          try {
            return format(parseISO(target), 'MMM d, yyyy');
          } catch {
            return target;
          }
        })()}
      </div>
      {/* silence unused */}
      <span className="sr-only">{label}</span>
    </div>
  );
}
